import React from 'react'
import moment from 'moment'

import { Div, H5, Span } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'

const setNote = (event) => ({__html: event.body.note.body})

const NoteEvent = ({event, name}) => {
  return (
    <Div className="contact-event--container">
      <Div className="contact-event--icon-long">
        <Icon name="article-create-2" width={20} />
      </Div>
      <Div className="contact-event--event-description">
        <H5>
          {event.body.author.name} added a note
        </H5>
        <Span>{moment(event.createdAt).format('MM/DD/YYYY hh:mm A')}</Span>
        <Div className="contact-event--note-output" dangerouslySetInnerHTML={setNote(event)}/>
      </Div>
    </Div>
  )
}

export default NoteEvent
